import {
  ToppingValueDto,
  getVariantByToppings,
  TypeInventory,
  Product,
  ProductType,
  DBProduct,
  getDbProductId,
} from "../";

export const useInventory = ({
  cartProducts,
}: {
  cartProducts: DBProduct[];
}) => {
  const maximumQuantity = (
    product: Product,
    selectedToppings?: ToppingValueDto[],
  ): number | undefined => {
    const variant = product.productToppingVariations
      ? getVariantByToppings(
          product.productToppingVariations,
          selectedToppings || [],
        )
      : undefined;
    const inventoryType: TypeInventory = (variant?.inventory?.type ||
      product?.inventory?.type) as TypeInventory;
    return TypeInventory.Build === inventoryType
      ? 0
      : variant
      ? variant.inventory?.units
      : product?.inventory?.units;
  };

  const canAddProduct = (
    product: Product,
    selectedToppings?: ToppingValueDto[],
    productDbId?: string,
  ): boolean => {
    const variant = product.productToppingVariations
      ? getVariantByToppings(
          product.productToppingVariations,
          selectedToppings || [],
        )
      : undefined;
    const inventoryType: TypeInventory = (variant?.inventory?.type ||
      product?.inventory?.type) as TypeInventory;
    if (inventoryType) {
      if (
        [TypeInventory.Limited, TypeInventory.Created].includes(inventoryType)
      ) {
        const dbId = variant
          ? getDbProductId({
              id: product.id,
              variationId: variant.id,
              toppings: selectedToppings,
            })
          : product.id;
        const cantProductsInCart =
          cartProducts.find((p) =>
            productDbId ? p.dbId === productDbId : p.dbId === dbId,
          )?.quantity || 0;
        const limit: number | undefined = variant
          ? variant.inventory?.units
          : product?.inventory?.units;
        if (limit && cantProductsInCart >= 0 && cantProductsInCart >= limit)
          return false;
        else return true;
      }
    }
    return true;
  };

  const productDisclaimer = (product: Product) => {
    const inventoryType: TypeInventory = product.inventory
      ?.type as TypeInventory;
    if (
      [TypeInventory.Limited, TypeInventory.Created].includes(inventoryType)
    ) {
      const limit: number | undefined = product.inventory?.units;
      return `Solo quedan ${limit} unidades.`;
    }
    if (inventoryType === TypeInventory.Build) {
      const daysToDelivery =
        product.inventory?.deliveryDays || product.inventory?.delivery_days;
      return `Este producto se realiza bajo pedido. Una vez realices tu orden recibirás tu pedido después de ${daysToDelivery} días en promedio.`;
    }
    return null;
  };

  const hasProductTypeInTheCart = (productType?: ProductType) => {
    const hasProductType = cartProducts.some((cp) => cp.type === productType);
    return hasProductType;
  };

  return {
    maximumQuantity,
    productDisclaimer,
    canAddProduct,
    hasProductTypeInTheCart,
  };
};
